import React, { useState } from 'react'
import Navbar from '../Navbar/Navbar'
import { useChangePasswordMutation } from '../../../Redux/Api/AuthApi'
import useAuth from "../../../MiddleWay/useAuth"

const ChangePassword = () => {
    const [msg,setMsg] = useState()
    const {id} = useAuth()
    const [errMsg,setErrMsg] = useState()
    const [passData,setPassData] = useState({
        newPassword:"",
        repeatPassword:""
    })
    const [changePassword,{isSuccess,isLoading}] = useChangePasswordMutation()

    const handleChange = (e)=>{
        const {name,value} = e.target
        setPassData((prev)=>({...prev,[name]:value}))
    }
    const dataSent = {...passData,id}

    const handleSubmit = async(e)=>{
      e.preventDefault()
    if (passData.newPassword !== passData.repeatPassword) {
      return setErrMsg("Passwords do not match");
    }

    if (passData.newPassword.length < 6) {
      return setErrMsg("Password must be at least 6 characters");
    }

     const response = await changePassword(dataSent)
     if(response?.data){
       return setMsg("Success")
     }
     return setErrMsg("Failed")
    }

  return (
    <div className=''>
     <Navbar/>
    <section className="kiga-portal-addStudent-section">
        <div className="kiga-portal-medical-section-form">
          <form onSubmit={handleSubmit}>
          <div className="kiga-portal-medical-section-form-title">
            <p><strong>Change Your Password</strong></p>
          </div>
          <div className="kiga-portal-medical-section-form-clinic-flex">
            <div className="kiga-portal-medical-section-form-clinic-label">
              <label>
                new Password:<span>*</span>
              </label>
            </div>
            <div className="kiga-portal-medical-section-form-clinic">
              <input type="password" name="newPassword" onChange={handleChange} placeholder="Password" value={passData.newPassword}/>
            </div>
          </div>
          <div className="kiga-portal-medical-section-form-clinic-flex">
            <div className="kiga-portal-medical-section-form-clinic-label">
              <label>
               repeat Password:<span>*</span>
              </label>
            </div>
            <div className="kiga-portal-medical-section-form-clinic">
              <input type="password" name="repeatPassword" onChange={handleChange} placeholder="retype Password"value={passData.repeatPassword}/>
            </div>
          </div>
          <div>{errMsg ? errMsg : msg ? msg : ""}</div>
          <div className="kiga-portal-medical-section-form-btn"><button type="submit">{isLoading ? 'Loading...' : 'Save'}</button></div>
          </form>
        </div>
      </section>
    </div>
  )
}

export default ChangePassword